export const environment = {
  env: 'production'
};
